import type { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import type React from 'react';

import { cn } from '@change/ds-utils';

type Props = Readonly<{ viewportSize: 'small' | 'normal' }>;

export const ResponsiveBox: React.FC<PropsWithChildren<Props & ComponentPropsWithoutRef<'div'>>> = ({
	children,
	viewportSize: size,
	className,
	...rest
}) => (
	<div {...rest} className={cn(size === 'small' ? 'block md:hidden' : 'hidden md:block', className)}>
		{children}
	</div>
);
